// extracted by mini-css-extract-plugin
export default {"range":"Range_range__kn+jW","label":"Range_label__Z5Jhe","amount":"Range_amount__989Gj","label_btm":"Range_label_btm__t5ySD"};